<template>
  <v-card class="mt-6" style="background-color: transparent;" elevation="0">
    <v-row class="d-flex align-center pl-2 pr-5 pr-md-10">
      <v-col cols="8" sm="8" md="9" class="d-flex pa-0">
        <v-card-text class="d-flex align-center pa-0"
          >
          <div class="mr-2">
            <v-icon
            style="background-color: #d32f2f"
            class="pa-2 rounded-lg"
            color="white"
            >{{ icon }}</v-icon
          >

          </div>
          <div class="d-flex flex-column" style="width: inherit;">
            <span
              @click="openPdfInNewTab(file)"
              style="cursor: pointer"
              class="blue--text text--darken-2 font-weight-medium text-subtitle-1 text-md-h6 short-text"
              >Comprobante {{ filename }}</span
            ><span class="grey--text text--darken-1 short-text"
              >Subido {{ createdTime | formatDateShort }}</span
            >
          </div>
        </v-card-text>
      </v-col>
      <v-col v-if="showAmount" cols="4" sm="4" md="3" class="pa-0">
        <v-card-text
          class="d-flex justify-end align-center pa-0 text-subtitle-1 text-md-h6 grey--text text--darken-1"
          ><span>$ {{ amount }}</span></v-card-text
        >
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "ProofItem",
  props: {
    filename: {
      type: String,
      required: true,
    },
    file: {
      type: String,
      required: true,
    },
    createdTime: {
      type: String,
      required: true,
    },
    amount: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      default: "description",
    },
    showAmount: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openPdfInNewTab(fileUrl) {
      if (fileUrl) {
        window.open(fileUrl, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.short-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
